module.exports = __webpack_public_path__ + "static/media/artist-visual-arts.fb569515.jpeg";